export const USER_ROLE = {
  SUPER_ADMIN: 1,
  WRITE_PRODUCT: 2,
  READ_PRODUCT: 3,
  WRITE_MASTER: 4,
  READ_BUSINESS: 5,
  WRITE_BUSINESS: 6,
  READ_CONTAINER: 7,
  WRITE_CONTAINER: 8,
};

export const USER_ROLE_LABEL: Record<number, string> = {
  [USER_ROLE.SUPER_ADMIN]: 'Super Admin',
  [USER_ROLE.WRITE_PRODUCT]: 'Escritura Productos',
  [USER_ROLE.READ_PRODUCT]: 'Lectura Productos',
  [USER_ROLE.WRITE_MASTER]: 'Escritura Maestros',
  [USER_ROLE.WRITE_BUSINESS]: 'Escritura Empresas',
  [USER_ROLE.READ_BUSINESS]: 'Lectura Empresas',
  [USER_ROLE.READ_CONTAINER]: 'Escritura Contenedores',
  [USER_ROLE.WRITE_CONTAINER]: 'Lectura Contenedores',
}

export const USER_ROLES = [
  { name: USER_ROLE_LABEL[USER_ROLE.SUPER_ADMIN], value: USER_ROLE.SUPER_ADMIN },
  { name: USER_ROLE_LABEL[USER_ROLE.WRITE_MASTER], value: USER_ROLE.WRITE_MASTER },
  { name: USER_ROLE_LABEL[USER_ROLE.WRITE_PRODUCT], value: USER_ROLE.WRITE_PRODUCT },
  { name: USER_ROLE_LABEL[USER_ROLE.READ_PRODUCT], value: USER_ROLE.READ_PRODUCT },
  { name: USER_ROLE_LABEL[USER_ROLE.WRITE_BUSINESS], value: USER_ROLE.WRITE_BUSINESS },
  { name: USER_ROLE_LABEL[USER_ROLE.READ_BUSINESS], value: USER_ROLE.READ_BUSINESS },
  { name: USER_ROLE_LABEL[USER_ROLE.WRITE_CONTAINER], value: USER_ROLE.WRITE_CONTAINER },
  { name: USER_ROLE_LABEL[USER_ROLE.READ_CONTAINER], value: USER_ROLE.READ_CONTAINER },
]